import {getBrandPageList} from "api/brands";
import BrandsListItem from "components/Brands/BrandsListItem/BrandsListItem";
import CategoryListItem from "components/Brands/BrandsListItem/CategoryListItem";
import LineList from "components/LineList/LineList";
import React, { useEffect } from "react";
import {useTranslation, withTranslation} from "react-i18next";
import { useDispatch, useSelector, connect } from "react-redux";
import { Link } from "react-router-dom";
import { setBrands, showLinearBrands } from "store/actions/brandsActions";
import "./BrandsList.scss";
import mapDispatchToProps from "react-redux/lib/connect/mapDispatchToProps";

const ListItem = ({ item }) => {
    if (item.type === "brand") {
        return (
            <Link
                draggable={false}
                className="brandlist_link"
                to={{
                    pathname: "/brands/categories/" + item.id,
                    state: { transitionName: "slide_in" },
                }}
            >
                <BrandsListItem
                    name={item.name}
                    logo={item.logo}
                    picture={item.picture}
                />
            </Link>
        );
    }
    if (item.type === "one_hr_categories") {
        return (
            <Link
                draggable={false}
                className="brandlist_link"
                to={{
                    pathname: "/oneHr/" + item.codeOneHr,
                    state: {transitionName: "slide_in"},
                }}
            >
                <CategoryListItem logo={item.logo} title={item.title}/>
            </Link>
        );
    }

    return (
        <a href={item.url}
           target={"_blank"}
           draggable={false}
           className="brandlist_link"
        >
            <CategoryListItem logo={item.picture} title={item.name}/>
        </a>
    );
};

const getKey = (item) => {
    if (item.type === "brand") {
        return `brand-${item.id}`;
    }

    return `category-${item.codeOneHr}`;
};

const BrandsList = () => {
    const { i18n } = useTranslation();
    const dispatch = useDispatch();
    const account = useSelector((state) => state.account);
    const display = useSelector((state) => state.brands.showLinearBrands);
    const data = useSelector((state) => state.brands.brandsList);

    useEffect(() => {
        if (account.monobrand) {
            displayInline();
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [i18n.language]);

    const fetchData = async () => {
        Promise.all([getBrandPageList()]).then(
            ([items]) => {
                dispatch(setBrands(items));
            }
        );
    };

    const displayInline = () => {
        dispatch(showLinearBrands("line"));
    };

    const displayGrid = () => {
        dispatch(showLinearBrands("grid"));
    };

    return (
        <>
            <div className="brandsBar">
                <button
                    className={display === "grid" ? "active grid" : "grid"}
                    onClick={displayGrid}
                ></button>
                <button
                    className={display === "line" ? "active line" : "line"}
                    onClick={displayInline}
                ></button>
            </div>
            {display === "grid" ? (
                <div className="brandslist">
                    {data.map((datum) => (
                        <ListItem item={datum} key={getKey(datum)} />
                    ))}
                </div>
            ) : (
                <LineList>
                    {data.map((datum) => (
                        <ListItem item={datum} key={getKey(datum)} />
                    ))}
                </LineList>
            )}
        </>
    );
};

//extract data from the redux store
const mapStateToProps = (state) => ({
  brands: state.brands,
  account: state.account,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(BrandsList));
